{
    "ChannelCode": "Κωδικός",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Εξερευνήστε περισσότερες λειτουργίες",
                "ThanksMessage": "Σας ευχαριστούμε που συμμετείχατε,",
                "WorkingMessage": "ελπίζουμε ότι η μετάφραση βελτίωσε την εμπειρία σας στην εκδήλωση."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "Πώς ήταν η ποιότητα της μετάφρασης;",
                "SessionClosedMessage": "Η ζωντανή μετάφραση ολοκληρώθηκε.",
                "ThankYouMessage": "Ελπίζουμε ότι αυτό βοήθησε!"
            }
        }
    },
    "Continue": "Συνέχεια",
    "Control": {
        "Original": "Πρωτότυπο",
        "Spacing": "Απόσταση",
        "TextSize": "Μέγεθος",
        "Tts": "TTS"
    },
    "Download": "Λήψη",
    "Idle": "Αδρανές",
    "Join": "Συμμετοχή",
    "LanguageSettings": "Γλώσσα",
    "Live": "Σε εξέλιξη",
    "Loading": {
        "Entering": "Είσοδος στο κανάλι",
        "Joining": "Συμμετοχή στο κανάλι"
    },
    "OK": "Εντάξει",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Παρακαλώ εισαγάγετε τον κωδικό καναλιού.",
            "InputPlaceholder": "Εισαγάγετε τον κωδικό καναλιού",
            "Title": "Να είστε παρών. Κατανοήστε τα πάντα."
        },
        "SelectLanguage": {
            "SearchEmpty": "Δεν βρέθηκε αντίστοιχη γλώσσα",
            "SearchPlaceholder": "Αναζήτηση γλώσσας",
            "Title": "Επιλέξτε τη γλώσσα μετάφρασης"
        }
    },
    "Pane": {
        "CatchUp": "Μετάβαση στο πιο πρόσφατο",
        "Source": "Πρωτότυπο",
        "Translation": "Μετάφραση",
        "Tts": "Ανάγνωση ομιλίας",
        "TtsShort": "TTS"
    },
    "Share": "Κοινοποίηση",
    "SpeechSpeed": "Ταχύτητα ομιλίας",
    "Start": "Έναρξη",
    "Submit": "Υποβολή",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "Αυτό το κανάλι έχει φτάσει το όριο συνδέσεων."
            }
        },
        "Icon": {
            "ScrollToBottom": "Επιστροφή στο πιο πρόσφατο",
            "ShareLink": "Κοινοποίηση συνδέσμου",
            "SpeechRate": "Ρύθμιση ταχύτητας αναπαραγωγής"
        }
    },
    "Toast": {
        "LanguageChanged": "Γλώσσα μετάφρασης: {lang}",
        "LinkCopied": "Ο σύνδεσμος αντιγράφηκε",
        "SourceOff": "Απόκρυψη πρωτοτύπου",
        "SourceOn": "Εμφάνιση πρωτοτύπου",
        "TtsOff": "Ομιλία ανενεργή",
        "TtsOn": "Ομιλία ενεργή"
    },
    "Transcript": {
        "Start": "Αρχή της απομαγνητοφώνησης"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Αρχικό Κείμενο",
            "summary": "Περίληψη",
            "transcript": "Απομαγνητοφώνηση"
        },
        "translationLanguage": {
            "title": "Γλώσσα μετάφρασης"
        }
    }
}
